import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["overflow"];

  showLoadingState() {
    this.overflowTarget.classList.remove("hidden");
  }
}
